import { detailAction } from '../actions/fetchdetail'
import { detailMutation } from '../mutations/fetchdetail'

export const detail = {
  state: {
    'detail/car': {
      data: {}
    },
    'detail/person': {
      data: {}
    },
    'detail/abstract': {
      data: {}
    },
		'detail/maintain': {
			data: {}
		},
		'detail/illegal': {
			data: {}
		},
		'detail/insurance': {
			data: {}
		},
		'detail/taobao': {
			data: {}
		},
		'detail/jingdong': {
			data: {}
		},
		'detail/security': {
			data: {}
		},
		'detail/securitydetail': {
			data: {}
		},
		'detail/executor': {
			data: {}
		},
		'detail/house': {
			data: {}
    },
    'detail/personalrisk': {
			data: {}
    }
  },
  mutations: detailMutation,
  actions: detailAction
}



// WEBPACK FOOTER //
// ./src/store/modules/fetchdetail.js